import { Controller } from "stimulus";
import debounce from 'lodash.debounce';
import Url from 'domurl'
import { Basics } from '../search/basics';
import {SearchItemContainer} from '../search/search_item_container';
import {searchFormHelpers} from '../search/search_form_helpers';
import {searchFormEvents} from '../search/search_form_events';
import {Field} from '../search/field';
import { Fields } from '../search/fields';
import GlobalOverlayManager from '../global_overlay_manager';
import Filter from '../filter'
import { getState, setState } from '../search_results/state'

export default class extends Controller {

  partialReloadType = {
    normal: 1,
    dateFormatChanged: 2
  }

  partialFormReloadType = this.partialReloadType.normal
  ignoreFullFormReload = true;
  filterUrl = null;
  root_url = "";

  connect() {
    /* Stuff we definitely still need */

    let filter = null;
    try {
      filter = getState('filter')
    } catch {
      // Looks like we havent built the filter yet.
      filter = new Filter(mapSupport.parsedFilter, mapSupport.locationFields)
    }

    // TODO: see if we can unpack this
    searchFormFlex.init(filter.locations());

    $('.c-card-group').flexCardGroup();
    this.root_url = $('#leftTool').src;

    this.setupDateFields();


    this.setupSelect2Handling()

    /* end stuff we definitely still need */

    Basics.previous_mls_ids = Basics.mls_id().val();

    new CarouselButton('#drawnShapesOperator');

    window.addEventListener('searchForm:dateFieldsReady', () => {
      this.setupDateFields();
    });

  }

  // Copied from /search/add_fields.js
  // Displays the Add Field modal
  addFields(evt) {
    let $dropdown = $(evt.target);
    if ($dropdown.css("display") == "none") {
      // Only need to hit the server if we are displaying the drop down
      showPageLoadingMsg();

      $dropdown.find('#find_field').val('').keyup(findField);

      fillAddFieldsDropdown().done(function() {
        hidePageLoadingMsg();
        $dropdown.find('#find_field').focus();
      });
    } // else no need to do anything here.  The dropdown will close without us doing anything.
  }

  // Copied from /search/add_fields.js addFieldListItemClickHandler
  // Adds a field to the form
  // This is a double event hit with the original add_fields version.  Need to remove the original.
  addField(evt) {
    evt.preventDefault();

    if ($(evt.target).parent().hasClass('included')) {
      return;
    }
    var field = new Field($(evt.target).data());
    searchFormFlex.getAndAddFieldsToForm([field]).done(function() {
      if (field.type === 'Boolean') {
        var serializedForm = searchFormHelpers.formSerializer();
        searchFormFlex.reloadData(serializedForm);
      }
    });
  }

  filterCheckboxChanged(evt) {
    evt.stopPropagation();
    searchFormFlex.filterCheckboxChanged(evt.target)
  }

  // Copied from /search/add_fields.js addAllFieldsClickHandler
  // Adds a field to the form
  // This is a double event hit with the original add_fields version.  Need to remove the original.
  addAllFields(evt) {
    evt.preventDefault();

    var fields = [];
    var groupName = $(evt.currentTarget).data("group-name");

    $('.add_a_field_list_item[data-group-name="' + groupName + '"]').each(function (i) {

      if ($(this).parent().hasClass('included')) {
        return;
      }

      var field = new Field($(this).data());
      fields.push(field);
    });

    searchFormFlex.getAndAddFieldsToForm(fields);
  }

  drawShapes(evt) {
    evt.preventDefault()

    if ($('#drawOnMapBtn').prop('disabled')) {
      return;
    }

    if (window.matchMedia('(max-width: 767px)').matches) {
      leftMenubarCloseClick()
    }

    if ($('.c-flex-content--map').length > 0) {
      // Map mode is already in place.  Pop up the 'Draw A Shape' menu
      dispatchEvent(new CustomEvent('map:drawShapes'));
    } else {
      // Enter map mode and tell the map controller to pop up the 'Draw A Shape' menu
      dispatchEvent(new CustomEvent('subnav:displayMapAndDrawShapes'));
    }
  }

  resetShapes(evt) {
    evt.preventDefault();
    $("#drawingsSelect").empty()
    var serializedForm = searchFormHelpers.formSerializer();
    searchFormFlex.reloadData(serializedForm);
  }

  // Copied from /search_results/search_results.js
  resetFilters(e) {
    e.preventDefault();

    // Create a one-time event handler for turbo-frame load
    const handleTurboLoad = () => {
      // Serialize the form and reload data after leftTool has finished loading
      // This resubmitts the form and updates all of the proper places with the filter change.
      var serializedForm = searchFormHelpers.formSerializer();
      searchFormFlex.reloadData(serializedForm, false);

      // Remove the listener after it's used
      document.removeEventListener('turbo:frame-load', handleTurboLoad);
    };

    // Set up the event listener before making the request
    document.addEventListener('turbo:frame-load', handleTurboLoad);

    // Force reload by temporarily clearing and restoring src
    // This gets the "fresh" form from the server.
    let currentSrc = $('#leftTool')[0].src;
    $('#leftTool')[0].src = '';
    $('#leftTool')[0].src = currentSrc;
  }

  selectChanged(evt) {
    let target = evt.target
    // If the item's container was not checked, check it now
    SearchItemContainer.checkContainer($($(target).closest('.c-card')), ($(target).find('option:selected').length > 0));

    if ($(".select2-container--open").length > 0 || evt.workInProgress) {
      // Any time a select2 is open, we want to let the user
      // finish what they are doing.
      // If workInProgress is set, something is happening where we want to wait till later to process the results
      return;
    }
    if (!$(target).hasClass('boolean-group-operator-select')) {
      SearchItemContainer.updateSelectSummary(target);
    }
    if (Basics.ids.includes(target.id)) {
      if (target.id == 'search_fields_MlsStatus_value' || target.id == 'search_fields_StandardStatus_value') {
        var myStatuses = $(target).val();
        searchFormFlex.updateStatusDates(myStatuses);
      } else if (target.id == 'search_fields_MlsId_value') {
        // This is the special case where we really do want to reload the entire form.
        Fields.reload(function (data) {
          // Tell anyone who cares to know that the form data as been reloaded with
          dispatchEvent(new CustomEvent('filterForm:reloaded', {detail: { count: data.count, expressions: data.expressions }}));

          $('.c-card-group').flexCardGroup();
          // TODO:  Make sure these are bound
          //bindDateExchange();
          //bindRelativeTimeAndDirection();
        });
        return;
      }
    }

    // Handle overlay shapes annotations
    if (target.id === 'overlayShapesSelect') {
      this.handleOverlayShapesAnnotations(target);
    }
    var serializedForm = searchFormHelpers.formSerializer();
    searchFormFlex.reloadData(serializedForm, false);
  }

  select2Changed(evt) {
    searchFormFlex.select2Changed(evt.target);
  }

  searchOperatorChanged(evt) {
    searchFormFlex.searchOperatorChanged(evt);
  }

  removeField(evt) {
    evt.preventDefault();
    searchFormFlex.removeField(evt.target);
  }

  textFocus(evt) {
    $(evt.target).attr("oldVal",$(evt.target).val());
  }

  textBlur(evt) {
    // TODO:  Check to see if this is a basics field that is changing.
    var isBasicsChange = false;

    var changedItem = $(evt.target);
    if (changedItem.attr("oldVal") == changedItem.val())
      return;

    // If the item's container was not checked, check it now
    SearchItemContainer.checkContainer(changedItem.closest('.c-card'), true);

    if (changedItem.closest(".controls.split").length == 1) {
      if ($(changedItem.closest(".controls.split")[0]).hasClass('contains-date')) {
        // Only the relative date controls have the contains-date class
        SearchItemContainer.updateRelativeDateSummary($(changedItem.closest(".controls.split")[0]));
      } else {
        SearchItemContainer.updateSplitControlsSummary($(changedItem.closest(".controls.split")[0]));
      }
    } else {
      changedItem.closest('.c-card').find('.c-card-enable-summary').text(changedItem.val());
    }

    var serializedForm = searchFormHelpers.formSerializer();
    searchFormFlex.reloadData(serializedForm, isBasicsChange);
  }

  addedFieldChanged(evt) {
    evt.stopPropagation();
    searchFormFlex.fieldCheckboxChanged(evt.target);
  }

  dateFieldChanged(evt) {
    if ($(".select2-container--open").length > 0) {
      // Any time a select2 is open, we want to let the user
      // finish what they are doing.
      return;
    }

    // If the item's container was not checked, check it now
    SearchItemContainer.checkContainer($(evt.currentTarget).closest('.c-card'), true);

    SearchItemContainer.updateSplitControlsSummary($($(evt.currentTarget).parent()[0]));

    var serializedForm = searchFormHelpers.formSerializer();
    searchFormFlex.reloadData(serializedForm, false)
  }

  undefined_action(evt) {
    console.log("We need to figure out how to get the right action assigned to this element.")
  }

  partialFormReload(evt) {
    if (this.partialFormReloadType == this.partialReloadType.dateFormatChanged) {
      this.partialFormReloadType = this.partialReloadType.normal
      this.updateListings();
    } else {
      this.partialFormReloadType = this.partialReloadType.normal
    }
  }

  fullFormReloaded(evt) {
    $('.c-card-group').flexCardGroup();
    // For some reason, these items still act differently than any other
    // elements.  Even the stimulus actions are not fired for these so we still
    // have to handle them separately.
    searchFormFlex.bindRelativeTimeAndDirection();
  }

  dateFormatChanged(evt) {
    // Switching between date range and relative dates
    var dateSwitch = $(evt.currentTarget);
    // If the item's container was not checked, check it now
    SearchItemContainer.checkContainer($(dateSwitch.closest('.c-card')), true);

    searchFormHelpers.toggleDateRelativity(dateSwitch);
    //searchFormHelpers.findCount();
    var isChangedToDateRange = ($('#'+ dateSwitch.attr('data-field-id').replace(/\"|\./g, '').replace(' ','_') + "_relative_container").css('display') == 'none')

    if (isChangedToDateRange) {
      SearchItemContainer.updateSplitControlsSummary($(dateSwitch.parent().find(".controls.split")[0]));
    } else {
      SearchItemContainer.updateRelativeDateSummary($('#'+ dateSwitch.attr('data-field-id').replace(/\"|\./g, '').replace(' ','_') + "_relative_container"));
    }
    this.updateListings(isChangedToDateRange);
  }

  relativeTimeOrDirectionChange(evt) {
    // IF WE CANNOT GET THESE ITEMS TO FIRE CORRECTLY, WE WILL NEED TO DELETE THIS ACTION.
    var target = $(evt.currentTarget);
    // If the item's container was not checked, check it now
    SearchItemContainer.checkContainer($(target.closest('.c-card')), true);

    var vals = target.hasClass("relative_time") ? ['days','months','years'] : ['back','ahead'] ;
    var currentVal = target.text();
    for (var x=0; x < vals.length; x++) {
      if (vals[x] == currentVal) {
        var new_val = x == vals.length-1 ? vals[0] : vals[x+1] ;
        target.text(new_val);
        $( "input[name='" + target.data("for") + "']").val(new_val);
      }
    }
    SearchItemContainer.updateRelativeDateSummary($(target.closest('.contains-date')[0]));

    this.updateListings();
  }

  drawnShapeNameChanged(evt) {
    let condition = evt.detail.targetShape
    $(`option[value="${condition}"]`).text(evt.detail.newName)

    // Find element by normalizing both the condition and element's data-shape attribute
    // One has spaces between commas and the next item.  The other does not.
    let normalizedCondition = condition.replaceAll(', ',',')
    var $parent = $(`span[data-shape]`).filter(function() {
      return $(this).attr('data-shape').replaceAll(', ',',') === normalizedCondition
    })

    // Find the text node and update it
    var $textNodes = $parent.contents().filter(function() {
      return this.nodeType === 3;
    });
    if ($textNodes.length) {
      $textNodes[0].nodeValue = evt.detail.newName;
    }
    SearchItemContainer.updateSelectSummary($('#drawingsSelect').closest('.c-card'));
  }

  drawnShapeColorChanged(evt) {
    let condition = evt.detail.targetShape
    $(`option[value="${condition}"]`).attr('data-color', evt.detail.newColor)

    // Find element by normalizing both the condition and element's data-shape attribute
    // One has spaces between commas and the next item.  The other does not.
    let normalizedCondition = condition.replaceAll(', ',',')
    $(`span[data-shape]`).filter(function() {
      return $(this).attr('data-shape').replaceAll(', ',',') === normalizedCondition
    }).find('.select2-color-circle').css('background-color', evt.detail.newColor)
}

  // 'private' helper methods

  setupSelect2Handling() {

    $(document).on('change', 'select:not(#locationSearch,#drawingsSelect,#templateSelect,.contact-select,#modal_overlays_select,.country-code-select)', (e) => {
      // If we are a regular select (instead of a select 2) we might already have the data action defined.
      // If so, no need to call it again.
      if ($(e.target).attr('data-action').includes('change->search-filters#selectChanged')) return;

      this.selectChanged(e);
    })

    $(document).on('select2:close', 'select:not(.contact-select,.country-code-select)', (e) => {
      this.selectChanged(e);
    })

    $(document).on('select2:opening', '#drawingsSelect', (e) => {
      // We cannot add drawings from here.
      // Dont show the dropdown if they start typing.
      e.preventDefault();
    })

    $(document).on('change', '#drawingsSelect', debounce(this.selectChanged.bind(this),500))
  }

  removeDeletedOptions(childSelector, parentOptions) {
    $(childSelector + ' option').each(function() {
      if (!parentOptions.includes($(this).val())) {
        $(this).remove();
      }
    });
  }

  updateListings(isChangedToDateRange = false, isBasicsChange = false) {
    var serializedForm = searchFormHelpers.formSerializer();
    if (isChangedToDateRange) {
      this.partialFormReloadType = this.partialReloadType.dateFormatChanged
    }
    searchFormFlex.reloadData(serializedForm, isBasicsChange)
  }

  viewListings(evt) {
    leftMenubarCloseClick()
  }

  listingCountTotalChanged(data) {
    searchFormHelpers.updateResultsButton(data.detail.newValue)
  }

  setupDateFields() {
    // A flatpickr calendar event changed the date.  We need to handle the event
    // here and pass it along to the actions.
    $('#basics-content .date_field').each((index, element) => {
      this.initializeFlatpickr($(element));
    });

    this.observeDateFieldAdditions();
  }

  initializeFlatpickr($input) {
    var existingValue = $input.val();
    $input.flatpickr({
      allowInput: true,
      dateFormat: "m/d/Y",
      disableMobile: "true",
      defaultDate: existingValue && existingValue.trim() !== '' ? existingValue : false,
      onChange: (selectedDates, dateStr, instance) => {
        instance.input.blur();
        // No need to dispatch the change event here.
        // It is handled by the dateFieldChanged action.
      }
    });
  }

  observeDateFieldAdditions() {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) {
            const dateFields = $(node).find('.date_field');
            dateFields.each((index, element) => {
              this.initializeFlatpickr($(element));
            });
          }
        });
      });
    });

    observer.observe($('#filterPanel')[0], {
      childList: true,
      subtree: true
    });
  }

  async filterChanged(data) {
    let newFilterString = data.detail.newValue.toString();
    let annotations = getState('annotations')

    if(window.searchResultsData){
      window.searchResultsData.filterString = newFilterString;
      window.searchResultsData.shapes = data.detail.newValue.shapes();
      window.searchResultsData.overlays = data.detail.newValue.overlays();
    }

    if ( window.mapSupport.originalFilter.toLowerCase() === newFilterString.toLowerCase() ) {
      $('#listingsHeader').removeClass('modified-search');
    } else {
      $('#listingsHeader').addClass('modified-search');
    }

    if (!$("#drawingsSelect").hasClass('dont_serialize')) {
      // Update the shape information on the form here so we dont have to reload the entire form
      var containsShapes = false;
      // Remove whatever shapes are defined in case the new filter has deleted one of the shapes.
      // We will add any that are still defined back to the select here.
      $("#drawingsSelect").find('option').remove().end();
      data.detail.newValue._data.every(function(expression) {
        if (expression.type == 'shape') {
          containsShapes = true;
          let annotation = annotations.filter(a => a['Type'] === 'Shape' && a['Match']['Substring'] === expression.condition)
          if (annotation.length === 0) {
            annotation = {"Label": "Shape", "Color": "0077d9"}
          } else {
            annotation = annotation[0]['Attributes']
          }
          $('#drawingsSelect').append($('<option value="' + expression.condition + '" selected="selected" data-color="#' + annotation['Color'] + '">' + annotation['Label'] + '</option>'));
        }
        return true;
      });

      if (!$('#drawingsSelect').hasClass('dont_serialize')) {
        if (containsShapes) {
          $("#drawingsSelectDiv").removeClass('no-shapes');
          $("#drawingsFooter").removeClass('no-shapes');
          $('div.drawn-shapes-prompt').show();
          $('div.drawn-shapes-prompt').prop('disabled',false);
          $('#drawingsSelect').prop('disabled',false);
        } else {
          $("#drawingsSelectDiv").addClass('no-shapes');
          $("#drawingsFooter").addClass('no-shapes');
        }
        SearchItemContainer.updateSelectSummary($('#drawingsSelect'));

      }
    }

    if (!$('#overlayShapesSelect').hasClass('dont_serialize')) {

      // Look through the filter and see if there are any overlay shapes to display
      let containsOverlays = data.detail.newValue._data.some(expression => expression.field === 'MapOverlayShape');

      if (containsOverlays) {
        SearchItemContainer.updateSelectSummary(document.getElementById('overlayShapesSelect'));
        $('#overlaysDiv').removeClass('no-overlays');
        $('#overlayShapesSelect').prop('disabled',false);
      }
    } // Else something in the filter changed other than overlays.  Keep the dropdowns in tact
    // because the user has unchecked the overlays box.  We dont want what is in the selects in the
    // filter, but we dont wont to delete them from the selects just yet.
  }

  handleOverlayShapesAnnotations(target) {
    const selectedValues = $(target).val() || [];

    let annotations = JSON.parse(JSON.stringify(getState('annotations')));

    // Remove existing overlay shape annotations
    annotations = annotations.filter(annotation => annotation.Type !== 'Overlay');

    // Add annotations for each selected overlay shape
    selectedValues.forEach(value => {
      // Find the option element for this value
      const option = $(target).find(`option[value="${value}"]`);
      if (option.length > 0) {
        const annotation = {
          Type: 'Overlay',
          Match: {
            Substring: value  // This is already the quoted ID like "'123456789'"
          },
          Attributes: {
            Shape: value.replace(/^'|'$/g, ''),  // Remove quotes to get the ID
            ShapeName: option.text(),
            Color: option.attr('data-color').replace('#', ''),
            // Overlay and OverlayName can be undefined or omitted
          }
        };
        annotations.push(annotation);
      }
    });

    // Update state and sessionStorage
    setState('annotations', annotations);
    sessionStorage.setItem('annotations', JSON.stringify(annotations));
  }


  updateFilterInUrl(oldUrl, filter) {
    var url = new Url(oldUrl);
    url.query._filter = filter;
    return url.toString();
  }

  tagRecentSearch(filter) {

    const token = document.querySelector('[name="csrf-token"]') || {content: 'no-csrf-token'}

    axios.put("tag_recent", {filter: filter}, {
      withCredentials: true,
      headers: {
        'X-CSRF-Token': token.content,
        accept: 'application/json'
      },
    }).catch((e) => {
      console.error(`Could not update recent search: ${e}`)
    });
  }

  drawnShapesOperatorClicked(evt) {
    evt.preventDefault();
    // Resubmit the form when the drawn shape operator changes
    let serializedForm = searchFormHelpers.formSerializer();
    searchFormFlex.reloadData(serializedForm, false);
  }
}
